import type { GridSortDirection, GridSortItem, GridSortModel } from '@mui/x-data-grid-pro'
import { Direction, ListColumnSetting } from './use-list-service/types'

interface ValidGridSortItem extends GridSortItem {
  sort: NonNullable<GridSortDirection>
}

export function isValidGridSortItem(sortItem: GridSortItem): sortItem is ValidGridSortItem {
  return sortItem.sort === 'asc' || sortItem.sort === 'desc'
}

function mapValidGridSortItemToListOrderBy(sortItem: ValidGridSortItem): string {
  return `${sortItem.field}|${sortItem.sort.toUpperCase()}`
}

export function mapSortModelToListOrderBy(sortModel: GridSortModel): string {
  const orderBy = sortModel.filter(isValidGridSortItem).map(mapValidGridSortItemToListOrderBy)

  return orderBy.join(',')
}

function mapListSortDirectionToGridSortDirection(direction: Direction | ''): GridSortDirection {
  if (direction === Direction.ASCENDING) return 'asc'
  if (direction === Direction.DESCENDING) return 'desc'
  return null
}

export function mapListSettingsToSortModel(settings: ListColumnSetting[]): GridSortModel {
  const settingsSortedBySortIndex = settings.slice().sort((a, b) => a.SortIndex - b.SortIndex)
  const settingsContainingSorting = settingsSortedBySortIndex.filter(setting => setting.SortDirection !== '')

  return settingsContainingSorting.map(setting => {
    return {
      field: setting.Name,
      sort: mapListSortDirectionToGridSortDirection(setting.SortDirection)
    }
  })
}
